import { render, staticRenderFns } from "./faqOne.vue?vue&type=template&id=23de540a&"
import script from "./faqOne.vue?vue&type=script&lang=js&"
export * from "./faqOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports